import React from "react";
import { DataHistoryLastWarehouseUpdate } from "../DataHistoryLastWarehouseUpdate/DataHistoryLastWarehouseUpdate";

export function ProductInWarehouseLastUpdate(props) {
	const dataHistory = props.dataHistory;
	if (!dataHistory || dataHistory.length === 0) {
		return null;
	}

	const warehouseId = props.warehouseId;
	if (!warehouseId) {
		return null;
	}
	const generalSource = "product-syncer";
	const targetSource = `product-syncer_${warehouseId}`;

	const filteredDataHistory = dataHistory.filter((dhe) =>
		dhe.source === targetSource || dhe.source === generalSource
	);
	return <DataHistoryLastWarehouseUpdate dataHistory={filteredDataHistory} />;
}